/**
 * The external dependencies.
 */
import React, { Component } from "react";
import styled from "styled-components";
import { Doughnut } from "react-chartjs-2";
import theme from "styles/theme";
import { FrameCell } from "styles/components/Frame";
import MediaQuery from "react-responsive";

/**
 * Class for deployment chart.
 *
 * @class      DeploymentChart (name)
 */
class DeploymentChart extends Component {
  state = {
    data: {
      labels: this.props.chartData.chartEntries.map((item) => item.label),
      datasets: [
        {
          data: this.props.chartData.chartEntries.map((item) => item.number),
          borderWidth: 0,
          hoverBorderWidth: 3,
          backgroundColor: this.props.chartColors,
          hoverBorderColor: this.props.chartColors,
          hoverBackgroundColor: this.props.chartColors,
        },
      ],
    },
    options: {
      maintainAspectRatio: false,
      cutoutPercentage: 57,
      legend: {
        display: false,
      },
      tooltips: {
        enabled: false,
      },
    },
  };

  getTotal() {
    let total = 0;

    this.props.chartData.chartEntries.forEach((item) => {
      total += item.number;
    });

    return total;
  }

  getLegendData() {
    const { chartData, chartColors } = this.props;
    return chartData.chartEntries.map((item, i) => ({
      ...item,
      color: chartColors[i],
    }));
  }

  render() {
    const {
      props: { onMouseEnter, onMouseLeave, selected, chartData },
      state: { data, options },
    } = this;

    return (
      <FrameCell flex>
        <FrameCell percent="45">
          <ChartLegend>
            {this.getLegendData().map((item, idx) => (
              <ChartLegendItem
                onMouseLeave={onMouseLeave}
                onMouseEnter={onMouseEnter(idx, item.number)}
                key={item.label + item.number}
              >
                <ChartLegendLabel>{item.label}</ChartLegendLabel>

                <MediaQuery maxWidth={1023}>
                  <ChartLegendValue small color={item.color}>
                    {item.number}
                  </ChartLegendValue>
                </MediaQuery>
                <MediaQuery minWidth={1024}>
                  <ChartLegendValue color={item.color}>{item.number}</ChartLegendValue>
                </MediaQuery>
              </ChartLegendItem>
            ))}
          </ChartLegend>
        </FrameCell>
        <FrameCell percent="55">
          <ChartWrapper>
            <Doughnut
              ref={(reference) => (this.chartReference = reference)}
              data={data}
              width={73}
              height={240}
              options={options}
            />

            <ChartOverlay>
              <ChartOverlayGroup>
                <MediaQuery maxWidth={1199}>
                  {chartData.chartTotalEntry.length > 3 ? (
                    <ChartTotalEntry smaller>{chartData.chartTotalEntry}</ChartTotalEntry>
                  ) : (
                    <ChartTotalEntry small>{chartData.chartTotalEntry}</ChartTotalEntry>
                  )}
                </MediaQuery>
                <MediaQuery minWidth={1200}>
                  {chartData.chartTotalEntry.length > 3 ? (
                    <ChartTotalEntry small>{chartData.chartTotalEntry}</ChartTotalEntry>
                  ) : (
                    <ChartTotalEntry>{chartData.chartTotalEntry}</ChartTotalEntry>
                  )}
                </MediaQuery>
              </ChartOverlayGroup>
            </ChartOverlay>
          </ChartWrapper>
        </FrameCell>
      </FrameCell>
    );
  }
}

const ChartWrapper = styled.div`
  position: relative;
  pointer-events: none;
  user-select: none;

  .chartjs-render-monitor {
    height: 275px !important;
  }
`;
const ChartOverlay = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
  padding-bottom: 16px;
  text-align: center;
`;
const ChartOverlayGroup = styled.div`
  margin-bottom: 10px;

  &:last-child {
    margin-bottom: 0;
  }
`;
const ChartTotalTitle = styled.h4`
  margin: 0 0 3px;
  font-size: 14px;
  line-height: 1;
  font-weight: 500;
  color: ${theme.color.dark_gray};
`;

const ChartLegendLabel = styled.span`
  display: inline-block;
  vertical-align: middle;
  text-transform: uppercase;
  font-size: 10px;
  font-weight: bold;
  color: ${theme.color.dark_gray};
`;

const ChartLegendValue = styled.div`
  font-size: 69px;
  font-weight: 500;
  line-height: 75px;
  color: ${(props) => props.color};

  ${(props) =>
    props.small &&
    `
    font-size: 59px;
  `}
`;

const ChartTotalEntry = styled.div`
  font-size: 69px;
  font-weight: 500;
  color: ${theme.color.darker_gray};

  ${(props) =>
    props.small &&
    `
    font-size: 54px;
  `}
  ${(props) =>
    props.smaller &&
    `
    font-size: 46px;
  `}
`;

const ChartLegend = styled.ul`
  list-style-type: none;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding-top: 30px;
  height: 300px;
  width: 180px;
  margin-right: 0px;
  margin-left: auto;

  li {
    padding-right: 10px;
  }
`;
const ChartLegendItem = styled.li`
  cursor: pointer;
  text-align: center;
`;

const ChartLegendDot = styled.div`
  display: inline-block;
  vertical-align: middle;
  margin-right: 5px;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: ${(props) => props.color};
`;

export default DeploymentChart;
